import { memo } from 'react';

import { type Clip } from '@air/api/types';
import { Spinner } from '@air/primitive-spinner';

import { isTitleAndMetadataVisibleSelector } from '~/store/configViews/selectors';
import { useAirSelector } from '~/utils/ReduxUtils';

export type PlaceholderAssetGalleryCardProps = {
  clip: Clip;
  cardWidth: number;
  cardHeight: number;
};

export const PlaceholderAssetGalleryCard = memo(({ clip }: PlaceholderAssetGalleryCardProps) => {
  const isTitleAndMetadataVisible = useAirSelector(isTitleAndMetadataVisibleSelector);
  const imageSrc = clip.assets?.image;

  return (
    <div
      data-testid="PLACEHOLDER_ASSET_CARD"
      className="pointer-events-none flex size-full flex-col rounded-16 ring-2 ring-transparent ring-inset"
    >
      <div className="relative grow">
        <div className="absolute inset-1 overflow-hidden rounded-12">
          {imageSrc && (
            // biome-ignore lint/performance/noImgElement: preview URL from canvas import, not eligible for Next.js Image optimization
            <img src={imageSrc} className="block min-h-full w-full rounded-12 object-cover" alt="" />
          )}
          <div className="shimmer-image-overlay absolute inset-0 rounded-12" />
        </div>
        <div className="absolute top-2 left-2 flex items-center gap-1 rounded-4 bg-black/60 p-1 backdrop-blur-sm">
          <Spinner className="size-4 text-white" />
          <span className="font-medium text-10 text-white">Processing…</span>
        </div>
      </div>
      {isTitleAndMetadataVisible && (
        <div className="relative mx-0.5 mt-1.5">
          <p className="truncate text-12 text-grey-11">Processing…</p>
        </div>
      )}
    </div>
  );
});

PlaceholderAssetGalleryCard.displayName = 'PlaceholderAssetGalleryCard';
